"use strict";
/*
 * Created on 01 04 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * EntityAttributeConverter
 *
 * @author JMe
 */


var EntityAttributeConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(EntityAttributeConverter, _DataObjectConverter_);

  function EntityAttributeConverter() {
    _classCallCheck(this, EntityAttributeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntityAttributeConverter).apply(this, arguments));
  }

  return EntityAttributeConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.EntityAttributeConverter = EntityAttributeConverter;